import { useGetBusinessShiftDetailsQuery } from "../../../features/businessShift/businessShiftApi";
import useError from "../../../hooks/useError";
import { formatDate, formatOnlyTime, formatTime } from "../../../lib/time";
import { ModalComponentProps } from "../../../types";
import InfoItem from "../../common/InfoItem";
import CustomModal from "../../ui/CustomModal";
import Loader from "../../ui/Loader";

export default function ShiftDetailsModal({
  handleClose,
  data,
  ...rest
}: ModalComponentProps) {
  const {
    isLoading,
    isError,
    error,
    data: shiftDetails,
  } = useGetBusinessShiftDetailsQuery(data || "", {
    skip: !data,
  });
  // error toast message
  useError(isError, error, "Get shift data fail");

  const detailsData = shiftDetails?.data;

  return (
    <CustomModal
      title="Shift Details"
      {...rest}
      handleClose={handleClose}
      width={800}
      footer={null}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <div className="grid grid-cols-2 gap-4">
          <div>
            <InfoItem title="Shift Name">{detailsData?.title}</InfoItem>
            <InfoItem title="Start Time">
              {detailsData?.start_time
                ? formatOnlyTime(detailsData?.start_time)
                : undefined}
            </InfoItem>
            <InfoItem title="Start Grace period">
              {detailsData?.checkin_grace_time}
            </InfoItem>
            <InfoItem title="End Time">
              {detailsData?.end_time
                ? formatOnlyTime(detailsData?.end_time)
                : undefined}
            </InfoItem>
            <InfoItem title="End Grace period">
              {detailsData?.checkout_grace_time}
            </InfoItem>
            <InfoItem title="Max Office Hour">
              {detailsData?.max_office_hours}
            </InfoItem>
          </div>
          <div>
            <InfoItem title="Created By">
              {detailsData?.created_by_name || undefined}
            </InfoItem>
            <InfoItem title="Created On">
              {detailsData?.created_at && detailsData?.created_by_name ? (
                <>
                  {formatTime(detailsData?.created_at)}{" "}
                  {formatDate(detailsData?.created_at)}
                </>
              ) : undefined}
            </InfoItem>
            <InfoItem title="Updated By">
              {detailsData?.updated_by_name || undefined}
            </InfoItem>
            <InfoItem title="Updated On">
              {detailsData?.updated_at && detailsData?.updated_by ? (
                <>
                  {formatTime(detailsData?.updated_at)}{" "}
                  {formatDate(detailsData?.updated_at)}
                </>
              ) : undefined}
            </InfoItem>
          </div>
        </div>
      )}
    </CustomModal>
  );
}
